export default __webpack_public_path__ + "static/media/Report.81446f67.svg";